export default __webpack_public_path__ + "static/media/black-logo-with-text.png";